import { useClientProfile } from '@/hooks/useClientProfile'
import { SIDE_LABEL, type SideRole } from '@/services/uwPropertyModels'
import { clientSideLabel } from './sponsorArepComparison'

export type SideLabels = Record<SideRole, string>

/** The two sides of a portfolio's models as this deployment names them: the
 *  sponsor, and the client's own short name (AREP) from the client profile -
 *  "Lender" until the profile answers. Never a client name in code (T-29). */
export function sideLabelsFor(profile: { shortName?: string | null; name?: string | null } | null | undefined): SideLabels {
  return { ...SIDE_LABEL, underwriter: clientSideLabel(profile) }
}

export function useSideLabels(): SideLabels {
  return sideLabelsFor(useClientProfile())
}
